import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from '../../styles/detalleEquipo.module.css';

const DetalleEquipo = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    void id;

    return (
        <div className={styles.container}>
            <button type="button" className={styles.backBtn} onClick={() => navigate('/creatividades/respuestas')}>
                ← Volver al listado
            </button>

            <header className={styles.header}>
                <h1 className={styles.title}>Resultado equipo</h1>
                <p className={styles.emptyState}>No hay datos disponibles para esta respuesta.</p>
            </header>
        </div>
    );
};

export default DetalleEquipo;
